// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Y3d3","content":"styles_content__2cjxt","checkbox":"styles_checkbox__10wxE","checkboxLabel":"styles_checkboxLabel__1roZx"};